import { Link } from "react-router-dom";
import { categoryPath } from "../lib/categories";

const RATIO_BY_SIZE = {
  xl: "aspect-[16/10]",
  sm: "aspect-[4/5]",
  md: "aspect-[4/3]",
};

const TITLE_CLASS_BY_SIZE = {
  xl: "font-serif text-3xl md:text-4xl lg:text-5xl font-light tracking-tight leading-[1.05]",
  sm: "font-serif text-xl font-medium tracking-tight leading-tight",
  md: "font-serif text-2xl font-medium tracking-tight leading-tight",
};

export default function ArticleCard({ post, size = "md" }) {
  const ratio = RATIO_BY_SIZE[size] || RATIO_BY_SIZE.md;
  const titleClass = TITLE_CLASS_BY_SIZE[size] || TITLE_CLASS_BY_SIZE.md;

  return (
    <article
      className="group flex flex-col gap-4"
      data-testid={`article-card-${post.slug}`}
    >
      <Link to={`/blog/${post.slug}`} className="card-img block">
        <div className={`${ratio} overflow-hidden rounded-card bg-[#f1eadb]`}>
          <img
            src={post.cover_image}
            alt={post.title}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
      </Link>
      <div className="flex items-center gap-3">
        <Link
          to={categoryPath(post.category)}
          className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#1e4a35] hover:text-[#10301f]"
        >
          {post.category}
        </Link>
        <span className="h-1 w-1 rounded-full bg-[#66726d]" />
        <span className="font-mono text-[10px] tracking-widest uppercase text-[#66726d]">
          {post.read_time} min read
        </span>
      </div>
      <Link to={`/blog/${post.slug}`}>
        <h3 className={`${titleClass} text-[#151e1a] group-hover:text-[#1e4a35] transition-colors`}>
          {post.title}
        </h3>
      </Link>
      {size !== "sm" && (
        <p className="text-[#404e48] font-light leading-relaxed line-clamp-3 max-w-prose">
          {post.excerpt}
        </p>
      )}
      <p className="font-mono text-[10px] tracking-widest uppercase text-[#66726d]">
        by {post.author_name}
      </p>
    </article>
  );
}
